export default __webpack_public_path__ + "static/media/dollar.674bac7e.svg";